import Vue from 'vue'
import Router from 'vue-router'
import MainAppBase from './views/MainAppBase'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'DefaultIndex',
      redirect: '/m/a/list'
    },
    {
      path: '/login',//登录
      name: 'Login',
      component: () => import('@/pages/login/index.vue')
    },
    {
      path: '/o/:iid',//跳转页面
      name: 'OUrl',
      component: () => import('@/pages/ourl/index.vue')
    },
    {
      path: '/m',
      component: MainAppBase,
      children: [{
        path: 'a/list',//线路
        name: 'ActivityList',
        component: () => import('@/pages/activity/List.vue')
      }, {
        path: 'schedule/index',//计调
        name: 'ScheduleIndex',
        component: () => import('@/pages/schedule/Index.vue')
      }, {
        path: 'personal/index',//我的
        name: 'PersonalIndex',
        component: () => import('@/pages/personal/Index.vue')
      }, {
        path: 'personal/order',//付尾款订单
        name: 'PersonalOrder',
        component: () => import('@/pages/personal/Order.vue')
      },{
        path: 'activity/enrollers',
        name: 'Enrollers',
        component: () => import('@/pages/activity/Enrollers.vue')
      }, {
        path: 'a/d',
        name: 'ActivityDetail',
        component: () => import('@/pages/activity/Detail.vue')
      }, {
        path: 'schedule/tourist',
        name: 'ScheduleTourist',
        component: () => import('@/pages/schedule/Tourist.vue')
      },{
        path: 'schedule/voucherist',
        name: 'ScheduleVoucherist',
        component: () => import('@/pages/schedule/Vouchers.vue')
      }, {
        path: 'schedule/material',
        name: 'ScheduleMaterial',
        component: () => import('@/pages/schedule/Material.vue')
      }, {
        path: 'personal/message',
        name: 'PersonalMessage',
        component: () => import('@/pages/personal/Message.vue')
      }, {
        path: 'personal/tour',
        name: 'PersonalTour',
        component: () => import('@/pages/personal/TourManage.vue')
      }, {
        path: 'personal/group',
        name: 'EditGroup',
        component: () => import('@/pages/personal/EditGroup.vue')
      }, {
        path: 'personal/newgroup',
        name: 'LeadInGroup',
        component: () => import('@/pages/personal/LeadInGroup.vue')
      }, {
        path: 'common/users',
        name: 'UserList',
        component: () => import('@/pages/common/UserList.vue')
      }, {
        path: 'common/calendar',
        name: 'EventCalendar',
        component: () => import('@/pages/common/EventCalendar.vue')
      }, {
        path: 'activity/enroll',
        name: 'Enroll',
        component: () => import('@/pages/activity/Enroll.vue')
      }, {
        path: 'activity/fodder',
        name: 'Fodder',
        component: () => import('@/pages/activity/Fodder.vue')
      },{
        path: 'saler/index',//销售
        name: 'SalerIndex',
        component: () => import('@/pages/saler/Index.vue'),
      },{
        path: 'saler/bills',
        name: 'SalerIndexBills',
        component: () => import('@/pages/saler/bills/index.vue'),
      },{
        path: 'saler/bills-edit',
        name: 'SalerIndexBillsEdit',
        component: () => import('@/pages/saler/bills/edit.vue'),
      },{
        path: 'saler/cashInInstead',
        name: 'SalerIndexCashInInstead',
        component: () => import('@/pages/saler/cashInInstead/index.vue'),
      },{
        path: 'saler/cashInInstead-edit',
        name: 'SalerIndexCashInInsteadEdit',
        component: () => import('@/pages/saler/cashInInstead/edit.vue'),
      },{
        path: 'saler/customerInset',
        name: 'SalerIndexCustomerInset',
        component: () => import('@/pages/saler/customerInset/index.vue'),
      },{
        path: 'saler/customerInset-edit',
        name: 'SalerIndexCustomerInsetEdit',
        component: () => import('@/pages/saler/customerInset/edit.vue'),
      },{
        path: 'saler/ownPath',
        name: 'SalerIndexOwnPath',
        component: () => import('@/pages/saler/ownPath/index.vue'),
      }, {
        path: 'bigdata/index',//数据
        name: 'BigDataIndex',
        component: () => import('@/pages/bigdata/Index.vue'),
      },{
        path: 'bigdata/list',//最新订单数据列表
        name: 'BigDataList',
        component: () => import('@/pages/bigdata/List.vue')
      }, {
        path: 'bigactdata/list',//线路查看定单
        name: 'BigActDataList',
        component: () => import('@/pages/bigdata/List_activity.vue')
      },{
        path: 'biggroupdata/list',//组团方查看订单
        name: 'BigGroupDataList',
        component: () => import('@/pages/bigdata/List_group.vue')
      },{
        path: 'bigsharedata/list',//组团方线路分享明细
        name: 'BigshareDataList',
        component: () => import('@/pages/bigdata/List_share.vue')
      },{
        path: 'bigsharedata/detail',//组团方线路分享明细
        name: 'BigshareDataDetail',
        component: () => import('@/pages/bigdata/List_share_item.vue'),
      },{
        path: 'bigdata/analysis',
        name: 'Analysis',
        component: () => import('@/pages/bigdata/Analysis.vue')
      }] 
    }
  ]
})
